import { createFileRoute } from '@tanstack/react-router';

import { TeamTab } from '@/components/settings/team/team-tab';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute('/_authenticated/settings/team')({
  loader: () => loadNamespaces('settings'),
  staticData: {
    title: 'route.settings_team.title',
  },
  component: TeamTab,
});
